export default __webpack_public_path__ + "static/media/message-call.a9ef8c33.png";